import cx from 'classnames'
import styles from './TextMessageContent.module.css'

export interface TextMessageContentProps {
  htmlContent: string
  bubble?: boolean
  testId?: string
}

export function TextMessageContent({
  htmlContent,
  bubble,
  testId,
}: TextMessageContentProps) {
  return (
    <div
      data-private
      data-test={testId}
      className={cx(styles.root, bubble && styles.bubble)}
      dangerouslySetInnerHTML={{
        __html: htmlContent,
      }}
    />
  )
}
